<template>
  <div class="footer-component">
    <div class="footer-wrap">
      <div class="social-section">
        <div class="image-wrapper">
          <img src="@/assets/images/logo-alt.png" />
        </div>
        <div class="social-container">
          <a :class="`social ${link.classes}`" v-for="(link, index) in socialLinks" v-bind:key="index" :href="link.url"
            :alt="link.classes" target="_blank">
          </a>
        </div>
      </div>
      <hr class="border" />
      <div class="navigation-section">
        <div class="navigation-copyright-wrap">
          <p class="copyright-copy">
            <span :class="copyright.classes">{{ copyright.title }}</span>
            <span :class="rightsReserved.classes">{{ rightsReserved.title }}</span>
          </p>
        </div>
        <div class="navigation-link-wrap">
          <div v-for="(link, index) in navigationLinks" v-bind:key="index" class="navigation-link-container">
            <!-- External links -->
            <a v-if="isExternalLink(link)" :href="link.url" class="navigation-link" target="_blank" rel="noopener noreferrer">
              {{ link.title }}
            </a>
            <!-- Internal links -->
            <router-link v-else :to="{ name: link.url }" class="navigation-link">
              {{ link.title }}
            </router-link>
          </div>
          <!-- OneTrust Cookie Preferences Link -->
          <div class="navigation-link-container">
            <a class="navigation-link ot-sdk-show-settings" style="cursor: pointer;">
              Cookie Preferences
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nav from '@/components/navigation';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'FooterMain',
  props: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState(nav.store.namespace, [
      'footerLinks',
      'socialLinks',
    ]),
    navigationLinks() {
      let copyrightClasses = ['copyright', 'all-rights-reserved']
      return this.footerLinks.filter(link => !copyrightClasses.includes(link.classes))
    },
    copyright() {
      return this.footerLinks.filter(link => link.classes === 'copyright')[0]
    },
    rightsReserved() {
      return this.footerLinks.filter(link => link.classes === 'all-rights-reserved')[0]
    }
  },
  methods: {
    isExternalLink(link) {
      // Check if the URL starts with http:// or https:// (external URL)
      return link.url && (link.url.startsWith('http://') || link.url.startsWith('https://'))
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';
@import 'element-theme-chalk/src/mixins/mixins.scss';

.copyright {
  color: $--color-white;
}

.copyright-copy {
  margin: 0;
  line-height: 1.75;
  white-space: nowrap;

  & span {
    padding: 0 10px 0 0;

    &:last-child {
      padding-left: 5px;

      &:before {
        content: '';
        position: relative;
        left: -10px;
        border-right: 1px solid;
      }
    }
  }
}

.all-rights-reserved {
  color: $--color-grayscale-3;
}

.border {
  color: $--color-grayscale-1;
  margin-bottom: 25px;
}

.footer-component {
  padding: 45px 0px;
  background-color: $--color-black;
  color: $--color-white;
}

.footer-wrap {
  margin-right: auto;
  margin-left: auto;
  padding-right: 20px;
  padding-left: 20px;
  max-width: 1300px;
}

.image-wrapper {
  width: auto;
  text-align: center;

  @include res(md-and-down, $--breakpoints-spec) {
    width: 100%;
    margin-bottom: 30px;
  }
}

.social-container {
  display: flex;
  gap: 20px;
  flex-wrap: nowrap;
  width: auto;

  @include res(md-and-down, $--breakpoints-spec) {
    width: 100%;
    justify-content: center;
    margin-bottom: 30px;
  }
}

.social {
  display: block;
  background-repeat: no-repeat;
  background-size: cover;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

a[target="_blank"]::after {
  display: none !important;
}

.icon-facebook {
  background-image: url('@/assets/images/facebook.png');
}

.icon-twitter {
  background-image: url('@/assets/images/twitter.png');
}

.icon-youtube {
  background-image: url('@/assets/images/youtube.png');
}

.icon-instagram {
  background-image: url('@/assets/images/instagram.png');
}

.social-section {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;

  @include res(md-and-down, $--breakpoints-spec) {
    flex-wrap: wrap;
  }
}

.navigation-section {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;

  @include res(md-and-down, $--breakpoints-spec) {
    flex-wrap: wrap;
    justify-content: center;
  }

}

.navigation-link-wrap {
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;

  @include res(md-and-down, $--breakpoints-spec) {
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
    margin-bottom: 15px;
    order: -1;
  }
}

.navigation-link {
  color: $--color-grayscale-3;
  font-family: $font-family;
  font-weight: normal;
  white-space: nowrap;

  &:hover {
    color: $--color-white;
  }
}

.navigation-link-container {
  padding: 0 20px;
  color: $--color-grayscale-3;

  &:last-of-type {
    padding-right: 0;

    &:after {
      display: none;
    }
  }

  &:after {
    content: '';
    position: relative;
    right: -20px;
    border-right: 1px solid;

    @include res(md-and-down, $--breakpoints-spec) {
      display: none;
    }
  }

  @include res(md-and-down, $--breakpoints-spec) {
    border: none;
    margin-bottom: 10px;
  }
}

.navigation-copyright-wrap {
  width: auto;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;

  @include res(md-and-down, $--breakpoints-spec) {
    justify-items: center;
  }
}
</style>
